import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UsersData {
  name: string;
  id: number;
}


@Component({
  selector: 'app-attended-appointment',
  templateUrl: './attended-appointment.component.html',
  styleUrls: ['./attended-appointment.component.css']
})
export class AttendedAppointmentComponent {

  action: string;
  local_data: any;

  constructor(
    public dialogRef: MatDialogRef<AttendedAppointmentComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  doAction() {
    this.dialogRef.close({ event: 'Accept', data: this.local_data });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
